module.exports = __webpack_public_path__ + "static/media/logo.d783c72f.svg";